module.exports = __webpack_public_path__ + "img/list-stars.8c7bd86a.svg";